<template>
  <ul-page class="page-virtual-grade" contentWidthFixed>
    <template v-slot:left>
      <div class="page-header-left">
        <div class="page-header-title">{{$t('virtual.grade')}}</div>
      </div>
    </template>
    <div class="page-content">
      <!-- <div class="link">实验地址：<a :href="link" target='_blank'>{{ link }}</a></div> -->
      <div class="filters">
        <ul-select class="select-teacher" v-if="userInfoInCourse.permissionGroupId == 1" v-model="params.teacherId" @change="currentTeacherChange">
          <ul-option
            v-for="item in teacherList"
            :key="item.userId"
            :label="item.name"
            :value="item.userId">
          </ul-option>
        </ul-select>
        <ul-select class="select-class" v-model="params.classId" :popper-append-to-body="false"  @change="getFirstPage">
          <ul-option
            v-for="item in teacherClassList"
            :key="item.classId"
            :label="item.className"
            :value="item.classId">
          </ul-option>
        </ul-select>
        <ul-input class="input-search"
          v-model="params.keyword"
          clearable
          suffix-icon="icon-quanshipei-sousuo"
          @keydown.native.enter="getFirstPage" 
          search
          @clear="getFirstPage"
          @search="getFirstPage"
          :placeholder="$t('virtual.enterNameOrStudentId')"
        ></ul-input>
      </div>
      <div class="tab-status">
        <div class="item" @click="getListByStatus(0)"><span class="label" :class="{active:params.status == 0}">{{$t('virtual.all')}}</span><span class="count">{{(stat.totalNum || 0)}}</span></div>
        <div class="item" @click="getListByStatus(1)"><span class="label" :class="{active:params.status == 1}">{{$t('virtual.finished')}}</span><span class="count">{{stat.completeNum || 0}}</span></div>
        <div class="item" @click="getListByStatus(2)"><span class="label" :class="{active:params.status == 2}">{{experimentType != 1 ? $t('virtual.learning') : $t('virtual.unfinished')}}</span><span class="count">{{stat.incompleteNum || 0}}</span></div>
        <div class="item" @click="getListByStatus(3)"><span class="label" :class="{active:params.status == 3}">{{$t('virtual.notStart')}}</span><span class="count">{{stat.notStartNum || 0}}</span></div>
      </div>
      <ul-table
        :data="gradeList"
        v-loading="loading"
        background
      >
      <ul-table-column
        prop="className"
        :label="$t('virtual.class')">
      </ul-table-column>
      <ul-table-column
        prop="userName"
        :width="experimentType == 1 ? '100px' : '180px'"
        :label="$t('virtual.name')">
      </ul-table-column>
      <ul-table-column
        prop="studentId"
        :width="experimentType == 1 ? '120px' : '180px'"
        :label="$t('virtual.studentId')">
      </ul-table-column>
      <ul-table-column
        prop="status"
        :width="experimentType == 1 ? '80px' : '140px'"
        :label="$t('virtual.status')">
        <template slot-scope="scope">
          <span v-if="experimentType != 1" :class="{'secondary-text-color': scope.row.status !== 1}">{{scope.row.status == 1 ? $t('virtual.finished'): scope.row.status == 2 ? $t('virtual.learning') : $t('virtual.notStart')}}</span>
          <span v-else :class="{'secondary-text-color': scope.row.status !== 1}">{{scope.row.status == 1 ? $t('virtual.finished'): $t('virtual.unfinished')}}</span>
        </template>
      </ul-table-column>
      <ul-table-column
        prop="learnProgress"
        v-if="experimentType != 3"
        :width="experimentType != 2 ? '68px' : '140px'">
        <template slot="header">
          <span>{{ $t('virtual.progress') }}</span>
          <span class="progress-info" @click.stop="showProgressInfo" title="指标定义">
            <img :src="exIcon" class="progress-info-icon" alt="指标定义" />
          </span>
        </template>
        <template slot-scope="scope">
          <span class="">{{ Math.round((scope.row.learnProgress || 0) * 100) + '%' }}</span>
        </template>
      </ul-table-column>
      <ul-table-column
        v-if="experimentType == 1"
        prop="startTime"
        width="148px"
        :label="$t('virtual.startTime')">
        <template slot-scope="scope">
          <span class="">{{scope.row.startTime | formatDate}}</span>
        </template>
      </ul-table-column>
      <ul-table-column
        v-if="experimentType == 1"
        prop="endTime"
        width="148px"
        :label="$t('virtual.endTime')">
        <template slot-scope="scope">
          <span class="">{{scope.row.endTime | formatDate}}</span>
        </template>
      </ul-table-column>
      <ul-table-column
        prop="learnProgress"
        v-if="experimentType == 3"
        width="144px"
        :label="$t('virtual.progress')">
        <template slot-scope="scope">
          <span class="">{{ Math.round((scope.row.learnProgress || 0) * 100) + '%' }}</span>
        </template>
      </ul-table-column>
      <ul-table-column
        v-if="experimentType != 2"
        prop="timeUsed"
        width="100px"
        :label="$t('virtual.duration')">
        <template slot-scope="scope">
          <div class="cell-timeUsed">
            <div>{{scope.row.timeUsed | duration}}</div>
          </div>
        </template>
      </ul-table-column>
      <ul-table-column
        prop="score"
        v-if="experimentType != 2"
        width="100px"
        :label="$t('virtual.grade')">
        <template slot-scope="scope">
          <div class="cell-timeUsed">
            <div>{{ scope.row.score === undefined || scope.row.score === null || isNaN(scope.row.score) || scope.row.score < 0 ? '--' : scope.row.score }}</div>
          </div>
        </template>
      </ul-table-column>
      <ul-table-column
        class-name="col-operate"
        width="100px"
        :label="$t('virtual.operate')">
        <template slot-scope="scope">
          <ul-dropdown
            @command="handleCommandexport($event, scope.row)"
            v-if="scope.row.joinTimes >= 1 && experimentType == 1"
            class="export-stu"
          >
            <ul-button size="small" class="ul-dropdown-link">
              <span class="button-text">{{$t('virtual.view')}}</span>
              <i class="iconfont icon-xialacaozuo"></i>
            </ul-button>
            <ul-dropdown-menu slot="dropdown" class="export-menu-stu">
              <ul-dropdown-item command="a">{{$t('virtual.view')}}</ul-dropdown-item>
              <ul-dropdown-item command="b">{{$t('virtual.reScore')}}</ul-dropdown-item>
            </ul-dropdown-menu>
          </ul-dropdown>
          <ul-button hollow size="small" v-else-if="experimentType == 2 && (scope.row.status == 2 || scope.row.status == 1)" @click="viewAiExperiment(scope.row)">{{$t('virtual.view')}}</ul-button>
          <span v-else>--</span>
        </template>
      </ul-table-column>
      </ul-table>
      <ul-pagination
        hide-on-single-page
        layout="prev, pager, next"
        :total="totalNum"
        :page-size.sync="params.ps"
        :current-page.sync="params.pn"
        @current-change="getGradeList"
      ></ul-pagination>
      <ul-dialog
        :title="$t('virtual.experimentScoreDetail')"
        :visible.sync = "experimentDetailDialogVisible"
        :close-on-click-modal="false"
        width="940px"
      >
        <experimentDetail :stuId="stuId" v-if="experimentDetailDialogVisible"></experimentDetail>
      </ul-dialog>

      <ul-dialog
        class="progress-info-dialog"
        :visible.sync="progressInfoDialogVisible"
        :close-on-click-modal="true"
        width="560px"
      >
        <template slot="title">
          <div class="progress-dialog-title">
            <img :src="progressInfoIcon" alt="说明" class="progress-info-dialog-icon" />
            <span><strong>说明</strong></span>
          </div>
        </template>
        <div class="progress-info-content">
          <p><strong>  指标定义：</strong>实验完成进度，用于衡量学生在实验课程中的任务完成情况，以实验目录节点为单位进行状态跟踪。</p>
          <p><strong>  计算方式：</strong>进度 =（已完成节点数 ÷ 实验总节点数）×100%，节点完成后会标记绿色对勾。</p>
        </div>
      </ul-dialog>
    </div>

    <ul-dialog
      width="550px"
      :title="$t('virtual.reScore')"
      class="re-scoring"
      :visible.sync="dialogVisible"
    >
      <ul-form ref="scoringForm" :model="form" :rules="rules" label-width="80px">
        <ul-form-item :label="$t('virtual.getScore')" prop="newScore">
          <ul-input
            class="score-input"
            v-model="form.newScore"
            type="number"
          />
          <span class="hint">{{$t('virtual.fullScoreHint')}}</span>
          <span>{{$t('virtual.originalScore')}}: {{ form.score }}{{$t('virtual.scoreUnit')}}</span>
        </ul-form-item>
        <ul-form-item :label="$t('virtual.comment')" prop="comment">
          <ul-input type="textarea" :placeholder="$t('virtual.addCommentPlaceholder')" :resize="'none'" v-model="form.comment" class="input"></ul-input>
        </ul-form-item>

      </ul-form>
      <span slot="footer" class="dialog-footer">
        <ul-button type="primary" @click="reScoring">{{$t('virtual.confirm')}}</ul-button>
        <ul-button plain @click="dialogVisible = false">{{$t('virtual.cancel')}}</ul-button>
      </span>
    </ul-dialog>
  </ul-page>
</template>

<script>
import {
  getVirtualGradeList,
  experimentScoreDetails,
  experimentTeaMark,
  getExperimentInfo,
} from '@/api/courseApi/virtual.js'
import { getUserOcRole, getOcTeacherClassList } from '@/api/courseApi'
import { mapGetters } from 'vuex'
import { formatDate, formatSeconds } from '@/utils'
import experimentDetail from './experimentDetail.vue'
export default {
  name: 'page-virtual-grade',
  data () {
    return {
      loading: true,
      experimentDetailDialogVisible: false,
      dialogVisible: false,
      progressInfoDialogVisible: false,
      exIcon: require('@/assets/images/virtual/circle_exclamation_mark.svg'),
      progressInfoIcon: require('@/assets/images/virtual/circle_exclamation_mark (2).svg'),
      userInfoInCourse: {},
      teacherList: [{
        userId: -1,
        name: this.$t('virtual.allTeacher'),
        classes: [{
          classId: -1,
          className: this.$t('virtual.allClass'),
        }]
      }],
      params: {
        teacherId: -1,
        classId: -1,
        keyword: '',
        status: 0,
        ps: 10,
        pn: 1
      },
      stat:{
        totalNum: 0,
        completeNum: 0,
        incompleteNum: 0,
        notStartNum: 0
      },
      gradeList: [],
      stuId: '',
      rules: {
        newScore: [
          { required: true, message: this.$t('virtual.enterScoreRule'), trigger:"blur" },
          { pattern: /^(100(\.0)?|[1-9]?\d(\.\d)?)$/, message: this.$t('virtual.scorePatternRule'), trigger: 'blur'},
        ],
        comment: [
          { min: 0, max: 500, message: this.$t('virtual.commentLimitRule'), trigger: 'blur' },
        ]
      },
      form: {
        newScore: 0,
        comment: ""
      },
      formRow: {},
      courseSchedId: '' // tonglab 实验记录使用
    }
  },
  computed: {
    ...mapGetters({ user: 'user/user' }),
    ocId () {
      return this.$route.query.ocId
    },
    experimentId () {
      return this.$route.query.experimentId
    },
    experimentType () {
      return this.$route.query.type
    },
    teacherClassList () {
      for (let i = 0; i < this.teacherList.length; i++) {
        const tea = this.teacherList[i];
        if (tea.userId == this.params.teacherId) {
          return tea.classes
        }
      }
      return []
    },
    totalNum () {
      if (this.params.status == 0) {
        return this.stat.totalNum
      }
      if (this.params.status == 1) {
        return this.stat.completeNum
      }
      if (this.params.status == 2) {
        return this.stat.incompleteNum
      }
      if (this.params.status == 3) {
        return this.stat.notStartNum
      }
    }
  },
  created () {
    window.test = this
    getUserOcRole(this.ocId)
      .then(result => {
        this.userInfoInCourse = result
        this.getTeacherList()
      })
    if (this.experimentType == 2) {
      getExperimentInfo({experimentId: this.experimentId})
      .then(({result}) => {
        this.courseSchedId = result.courseSchedId
      })
    }
  },  
  methods: {
    getScoreDetails() {
      experimentScoreDetails({recordId: this.formRow.recordId })
      .then(({result}) => {
        this.form = result
      })
    },
    showProgressInfo () {
      this.progressInfoDialogVisible = true
    },
    reScoring() {
      this.$refs.scoringForm.validate((valid) => {
        if (valid) {
          experimentTeaMark({
            recordId: this.formRow.recordId,
            newScore: this.form.newScore,
            comment: this.form.comment || ""
          })
          .then(() => {
            this.$message({
              message: this.$t('virtual.modifySuccess'),
              type: 'success'
            })
            this.dialogVisible = false
            this.getGradeList()
          })
        }
      })
    },
    handleCommandexport(e, row) {
      console.log(e, row);
      if (e == 'a') {
        this.viewDetail(row)
      } else {
        this.formRow = JSON.parse(JSON.stringify(row))
        this.dialogVisible = true
        this.getScoreDetails()
        this.$nextTick(()=> {
          this.$refs.scoringForm.resetFields();
        })
      }
    },
    viewAiExperiment (item) {
      var router =this.$router.resolve({
        path: `/experiment/teaView/${this.experimentId}`,
        query: {
          teacherId: this.params.teacherId,
          classId: this.params.classId,
          loginName: item.loginName,
          ocId: this.ocId,
          courseSchedId: this.courseSchedId
        }
      })
      window.open(location.origin + location.pathname + router.href)
    },
    isClassInList (item,list) {
      for (let i = 0; i < list.length; i++) {
        const ele = list[i];
        if (item.classId == ele.classId) {
          return true
        }
      }
      return false
    },
    getTeacherList () {
      getOcTeacherClassList(this.ocId)
        .then((result) => {
          this.teacherList = []
          let allClassList = []
          result.list.forEach(item => {
            if (item.classes.length > 0) {
              this.teacherList.push(item)
              for (let i = 0; i < item.classes.length; i++) {
                const cl = item.classes[i]
                if (!this.isClassInList(cl, allClassList)) {
                  allClassList.push(cl)
                }
              }
            }
          })
          this.teacherList.unshift({
            userId: -1,
            name: this.$t('virtual.allTeacher'),
            classes: allClassList
          })
          this.teacherList.forEach(item => {
            item.classes.unshift({
              classId: -1,
              className: this.$t('virtual.allClass'),
            })
          })
           this.params.teacherId = this.userInfoInCourse.userId
            if (this.teacherClassList.length == 0) {
              this.params.teacherId = -1
            }
            this.currentTeacherChange()
        })
    },
    currentTeacherChange () {
      this.params.classId = -1
      this.params.pn = 1
      this.getGradeList()
    },
    getFirstPage () {
      this.params.pn = 1
      this.getGradeList()
    },
    getListByStatus (status) {
      
      this.params.status = status
      this.params.pn = 1
      this.getGradeList()
    },
    getGradeList () {
      let params = {...this.params}
      params.experimentId = this.experimentId
      params.ocId = this.ocId
      params.teacherId = params.teacherId === -1 ? undefined : params.teacherId
      params.classId = params.classId === -1 ? undefined : params.classId
      params.status = params.status || undefined
      params.experimentType = this.experimentType
      this.loading = true
      this.gradeList = []
      getVirtualGradeList(params)
        .then(({result}) => {
          this.stat.totalNum = result.totalNum || 0
          this.stat.incompleteNum = result.incompleteNum || 0
          this.stat.completeNum = result.completeNum || 0
          this.stat.notStartNum = result.notStartNum || 0
          this.gradeList = result.list || []
          this.loading = false
        })
        .catch( ()=> {
          this.loading = false
        })
    },
    viewDetail (stu) {
      this.stuId = stu.userId
      this.experimentDetailDialogVisible = true
    }
  },
  filters: {
    duration (time) {
      return formatSeconds(time) || '--'
    },
    formatDate (time) {
      return formatDate(time) || '--'
    }
  },
  components: {
    experimentDetail
  }
}
</script>

<style lang="scss" scoped>
.page-content{
  margin-top: 24px;
  padding: 32px;
  .link {
    padding-bottom: 20px;
    border-bottom: 1px dashed #969696;
    margin-bottom: 20px;
  }
}
.page-title{
  padding-bottom: 20px;
  border-bottom: $--border-dashed;
  font-size: 16px;
  font-weight: 600;
}
.filters{
  .ul-select{
    margin-right: 10px;
  }
  .select-teacher{
    width: 110px;
  }
  .select-class{
    width: 180px;
  }
  .input-search{
    width: 200px;
  }
}
::v-deep.export-stu{
  .ul-dropdown-link {
    color: #ea5947;
    background: #fff;
    .button-text {
      display: inline-block;
      width: 46px;
      text-align: left;
    }
    .icon-xialacaozuo {
      font-size: 12px;
      transform: scale(0.7);
      display: inline-block;
    }
  }
}
::v-deep.re-scoring {
  .score-input {
    width: 110px;
  }
  .hint {
    color: #969696;
    margin: 0 20px 0 10px;
  }
  .input {
    width: 400px;
    textarea {
      height: 80px;
    }
  }
}
.tab-status{
  padding: 20px 0 12px;
  .item{
    margin-right: 20px;
    display: inline-block;
    cursor: pointer;
  }
  .label{
    font-weight: bold;
    &.active{
      color: $--color-primary;
    }
  }
  .count{
    color: $--color-text-secondary;
    margin-left: 4px;
  }
}
.ul-pagination{
  text-align: center;
  margin-top: 15px;
}

.progress-info{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #f0f0f0;
  color: #666;
  text-align: center;
  font-size: 14px;
  margin-left: 8px;
  cursor: pointer;
  vertical-align: text-bottom;
}
.progress-info-icon{
  width: 16px;
  height: 16px;
  display: inline-block;
}
.progress-info-content{
  padding: 8px 4px;
  color: #333;
}
.progress-dialog-title{
  display: inline-flex;
  align-items: center;
  line-height: 1;
}
.progress-info-dialog-icon{
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
.progress-dialog-title span{
  font-size: 18px;
  font-weight: 700;
  color: #333;
}
</style>